module.exports = __webpack_public_path__ + "5b3d70913c2b9c43527c5bcbafd14d56.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/clarity-ui-icons.eot
// module id = 670
// module chunks = 0